import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://onboardmarketing.nz";
const DEFAULT_DESC =
  "A small team of creative, strategic people helping New Zealand businesses grow through thoughtful branding, content, and marketing.";

/**
 * Per-page SEO tags. Renders <title>, meta description,
 * canonical, OpenGraph and Twitter tags.
 */
export default function SEO({ title, description, image, type = "website" }) {
  const { pathname } = useLocation();
  const url = SITE + (pathname === "/" ? "/" : pathname);
  const fullTitle = title
    ? `${title} | Onboard Marketing`
    : "Onboard Marketing. Marketing that feels like part of your team.";
  const desc = description || DEFAULT_DESC;
  const ogImage = image || `${SITE}/og-image.jpg`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={type} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
